module.exports = __webpack_public_path__ + "static/media/detail-penumpang.48e8a298.svg";